(function(ELEMENT) {
	ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;
	ELEMENT.closest = ELEMENT.closest || function closest(selector) {
		if (!this) return null;
		if (this.matches(selector)) return this;
		if (!this.parentElement) {return null}
			else return this.parentElement.closest(selector)
		};
}(Element.prototype));

(function($, $document) {
	const headerSearchBlock = document.querySelector('.site-header__search');
	if ( headerSearchBlock ) {
		const closeMobileSearch = function() {
			if ( window.innerWidth >= 1140 ) {
				return true;
			}

			if ( headerSearchBlock.classList.contains('toggle-on') ) {
				headerSearchBlock.classList.remove('toggle-on');
			}
		};

		const stopPropagationEvent = function(e) {
			e.stopPropagation();
		};

		document.getElementById('open-search').addEventListener('click', function(e) {
			e.stopPropagation();
			headerSearchBlock.classList.toggle('toggle-on');
		}, {passive: true});

		headerSearchBlock.addEventListener('scroll', stopPropagationEvent, {passive: true});
		headerSearchBlock.addEventListener('click', stopPropagationEvent, {passive: true});
		headerSearchBlock.addEventListener('touchstart', stopPropagationEvent, {passive: true});

		window.addEventListener('scroll', closeMobileSearch, {passive: true});
		document.body.addEventListener('click', closeMobileSearch, {passive: true});
		document.body.addEventListener('touchstart', closeMobileSearch, {passive: true});
	}

	document.getElementById('to-top-wrapper').addEventListener('click', function() {
		window.scrollTo({
			top: 0,
			behavior: "smooth"
		});
	}, {passive: true});

	document.getElementById('toggle-menu').addEventListener('click', function() {
		document.querySelector('.site-header__navigation').classList.toggle('toggle-on');
	}, {passive: true});

	document.querySelector('.search-form__clear').addEventListener('click', function() {
		document.querySelector('.search-form__input').value = '';
	}, {passive: true});

	$document.on('click', '.faq-item__question', function() {
		const $this = $(this),
		$faq = $this.closest('.faq-item');

		$faq.find('.faq-item__answer').slideToggle();
	});

	$document.on('change', 'input[name="rating"]', function() {
		const $this = $(this);
		$this.prevAll('label').addClass('active');
		$this.nextAll('label').removeClass('active');
	});

	const scrollToAnchor = function(e) {
		let targetURL = {};
		const hrefAttr = this.href;

		try {
			targetURL = new URL(hrefAttr);
		} catch(e) {
			if ( hrefAttr.match(/^#/) ) {
				targetURL = {
					hash: hrefAttr,
				};
			}
		}

		if ( ! targetURL.hash ) {
			return true;
		}

		const targetElement = document.getElementById(targetURL.hash.substring(1));

		if ( targetElement ) {
			e.preventDefault();

			window.scrollTo({
				top: targetElement.offsetTop,
				behavior: "smooth",
			});

			return false;
		}

		return true;
	};

	document.addEventListener('click', function(e) {
		const target = e.target;

		if ( 'a' === target.tagName.toLowerCase() ) {
			scrollToAnchor.call(target, e);
		}
	});

	$document.on('click', '.benefits__label', function() {
		$(this).next().slideToggle();
	});

	const $toTopButton = $('#to-top-wrapper');
	if ( $toTopButton.length ) {
		$toTopButton.hide();
		let timer = null;

		const showToTop = function() {
			if ( window.pageYOffset < 300 ) {
				return true;
			}

			$toTopButton.addClass('active').fadeIn();
		}

		const hideToTop = function() {
			$toTopButton.removeClass('active').fadeOut();
		}

		const _mobileToTop = function() {
			clearTimeout(timer)
			hideToTop();

			timer = setTimeout(showToTop, 3000);

			window.addEventListener('scroll', _mobileToTop);
			window.addEventListener('touchstart', _mobileToTop);
		};

		const _desktopToTop = function() {
			if ( window.pageYOffset > 300 ) {
				if ( ! $toTopButton.hasClass('active') ) {
					showToTop();
				}
			} else if ( $toTopButton.hasClass('active') ) {
				hideToTop();
			}
		};

		window.addEventListener('scroll', function() {
			if ( window.innerWidth > 768 ) {
				_desktopToTop();

				window.removeEventListener('scroll', _mobileToTop);
				window.removeEventListener('touchstart', _mobileToTop);
				clearTimeout(timer);
			} else {
				_mobileToTop();
			}
		}, {passive: true});
	}

	const autocompleteSearchInit = function(e) {
		const { target: { tagName, classList, type } } = e;

		if ( 'input' === tagName.toLowerCase() && 'text' === type && classList.contains('autocomplete-input') ) {
			document.removeEventListener('focusin', autocompleteSearchInit);
			const script = document.createElement('script');
			script.async = true;
			script.src = RSA.scripts.autocomplete;
			document.body.appendChild(script);
		}
	};
	document.addEventListener('focusin', autocompleteSearchInit, { passive: true });
})(jQuery, jQuery(document));

(function() {
	const eyeMove = function(e) {
		const leftEye 		= this.querySelector('.eye-left');
		const rightEye		= this.querySelector('.eye-right');

		if ( ! leftEye && ! rightEye ) {
			return true;
		}

		if ( leftEye ) {
			movePupil.call( leftEye, leftEye.closest('.eyes'), e.clientX, e.clientY );
		}

		if ( rightEye ) {
			movePupil.call(rightEye, rightEye.closest('.eyes'), e.clientX, e.clientY );
		}
	};

	const isElement = function ( obj ) {
		try {
			return obj instanceof HTMLElement;
		} catch( e ){
			return (typeof obj==="object") &&
			(obj.nodeType===1) && (typeof obj.style === "object") &&
			(typeof obj.ownerDocument ==="object");
		}
	};

	const movePupil = function( wrapper, mouseX = 0, mouseY = 0 ) {
		if ( ! isElement( wrapper ) ) {
			return;
		}

		const wrapperBoundaries = wrapper.getBoundingClientRect();

		let translateX = 0;
		let translateY = 0;

		const verticalBreakpoint = wrapperBoundaries.top + wrapper.offsetHeight / 2;
		const horizontalBreakpoint = wrapperBoundaries.left + wrapper.offsetWidth / 2;

		const pupil		= this.querySelector('.pupil');

		const maxOffset	= (this.offsetWidth - pupil.offsetWidth) / 2;

		if ( mouseY < verticalBreakpoint ) {
			const percent = mouseY * 100 / verticalBreakpoint;
			translateY = -1 * Math.min( maxOffset - maxOffset / 100 * percent, maxOffset);
		} else if ( mouseY > verticalBreakpoint ) {
			const percent = ( mouseY - verticalBreakpoint ) * 100 / ( document.documentElement.clientHeight - verticalBreakpoint );
			translateY = Math.min( maxOffset / 100 * percent, maxOffset);
		}

		if ( mouseX < horizontalBreakpoint ) {
			const percent = mouseX * 100 / horizontalBreakpoint;
			translateX = -1 * Math.min( maxOffset - maxOffset / 100 * percent, maxOffset);
		} else if ( mouseX > horizontalBreakpoint ) {
			const percent = ( mouseX - horizontalBreakpoint ) * 100 / ( document.documentElement.clientWidth - horizontalBreakpoint );
			translateX = Math.min( maxOffset / 100 * percent, maxOffset);
		}

		pupil.style.transform 	= `translate(${translateX}px, ${translateY}px)`;
	}

	const parallaxEffect = function(e) {
		this.querySelector('.lines').style.transform = `translate(-${(e.pageX - this.offsetLeft) / 150}px,-${(e.pageY - this.offsetTop) / 150}px)`;
		this.querySelector('.squares').style.transform = `translate(${(e.pageX - this.offsetLeft) / 500}px,${(e.pageY - this.offsetTop) / 500}px)`;
	};

	const parallaxBlocks = document.getElementsByClassName('parallax');
	if ( parallaxBlocks ) {
		document.body.addEventListener('mousemove', function(e) {
			for ( let i = 0; i < parallaxBlocks.length; i++) {
				window.requestAnimationFrame(parallaxEffect.bind(parallaxBlocks[i], e));
			}
		}, {passive: true});
	}

	const eyes = document.querySelector('.eyes');
	if ( eyes ) {
		document.body.addEventListener('mousemove', function(e) {
			window.requestAnimationFrame(eyeMove.bind(eyes, e));
		}, {passive: true});
	}

	$(function(){
		$('#showAllCards').click(function(){
			jQuery(this).remove();
			$('#reviews-cards article.filter-card:nth-of-type(n+6)').slideToggle('');
		});
	});
})();

// (function($, $document) {
// 	const loadSelectionModal = function() {
// 		$.get(RSA.ajaxurl, {action: 'rsa_load_spy_app_selection_modal', nonce: RSA.nonce}, function(response) {
// 			$('body').append(response);
// 			openSelectionModal();
// 		}, 'html');
// 	};
//
// 	$document.on('click', '.header-cta', function() {
// 		if ( 'undefined' === typeof window.openSelectionModal ) {
// 			loadSelectionModal();
// 			return true;
// 		}
//
// 		openSelectionModal();
// 	});
// })(jQuery, jQuery(document));